import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ERROR_CONFIG_PROVIDERS } from '@core/modules/error/error.config';
import { StoreFeatureName } from './models';
import { reducer } from './store';
import { ErrorEffects } from './store/error.effects';

@NgModule({ imports: [StoreModule.forFeature(StoreFeatureName.Error, reducer),
        EffectsModule.forFeature([ErrorEffects])], providers: [...ERROR_CONFIG_PROVIDERS, provideHttpClient(withInterceptorsFromDi())] })
export class ErrorModule {}
